export const ExternalFormFields = {
  TYPE: "type",
  TRAFFIC_VOLUME: "traffic_volume",
  WEBSITE_URL: "website_url",
  WORKING_VERTICALS: "working_verticals",
  USAGE_PLANS: "usage_plans",
  OTHER_PROVIDER: "other_provider",
};

export const ExternalFormWorkerTypes = {
  WEB_SITE_OWNER: "web-site-owner",
  AFFILATE_MEDIA_AGENCY: "affilate-media-agency",
  APP_DEVELOPER: "app-developer",
  OTHER: "other",
};

export const ExternalFormLeadSource = {
  MARKETING: "marketing",
};
